import {
  LOAD_VEHICLETYPE_CONFIG,
  SHOW_VEHICLETYPE_CONFIG,
  CREATE_VEHICLETYPE_CONFIG,
  UPDATE_VEHICLETYPE_CONFIG,
  DELETE_VEHICLETYPE_CONFIG,
  IMPORT_VEHICLETYPE_CONFIG,
  EXPORT_VEHICLETYPE_CONFIG
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    name: "",
    code: "",
    company_id: "",
    vehicle_type_id: "",
    min_value: "",
    max_value: "",
    min_order_fee: ""
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_VEHICLETYPE_CONFIG.REQUEST:
    case UPDATE_VEHICLETYPE_CONFIG.REQUEST:
    case DELETE_VEHICLETYPE_CONFIG.REQUEST:
    case IMPORT_VEHICLETYPE_CONFIG.REQUEST:
    case EXPORT_VEHICLETYPE_CONFIG.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case LOAD_VEHICLETYPE_CONFIG.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case SHOW_VEHICLETYPE_CONFIG.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false
      };

    case LOAD_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true
      };
    case IMPORT_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_VEHICLETYPE_CONFIG.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_VEHICLETYPE_CONFIG.FAILURE:
    case SHOW_VEHICLETYPE_CONFIG.FAILURE:
    case CREATE_VEHICLETYPE_CONFIG.FAILURE:
    case UPDATE_VEHICLETYPE_CONFIG.FAILURE:
    case DELETE_VEHICLETYPE_CONFIG.FAILURE:
    case IMPORT_VEHICLETYPE_CONFIG.FAILURE:
    case EXPORT_VEHICLETYPE_CONFIG.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false
      };

    default:
      return state;
  }
};
